var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8132 28.0744L26.3156 16.5719",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0879 15.598L27.1287 15.5772L27.1079 25.618",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6cdc7b5410a3378560b41e07393ac9d9.svg";
export { ForwardRef as ReactComponent };